<template>
  <div />
</template>

<script setup>
import {
  ref, onBeforeMount,
} from 'vue'
import { loadStripe } from '@stripe/stripe-js'

const props = defineProps({
  session: {
    type: Object,
    default: () => {},
  },
})

const stripeKey = ref(process.env.MIX_STRIPE_PUBLISHABLE_KEY)

onBeforeMount(async () => {
  const stripeObj = await loadStripe(stripeKey.value)
  stripeObj.redirectToCheckout({ sessionId: props.session.id })
})
</script>
